import React, { useEffect } from 'react'
import CommonBanner from "../component/CommonBanner";
import "../assets/css/TermsConditions.css";
import { useLocation } from 'react-router-dom';

const TermsConditions = () => { 

 const { pathname } = useLocation();

useEffect(() => {
  if (pathname === "/privacy-policy") {
    document.getElementById("policy")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  } else if (pathname === "/disclaimer") {
    document.getElementById("disclaimer")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, [pathname]);

  const breadcrumb = [
    {
      page: "Home",
      url: "/",
    },
    {
      page: "Terms and Conditions",
      url: "/terms-and-conditions",
    },
  ];


  return (
    <>
      <CommonBanner
        title="Terms and Conditions"
        image="/images/policy.png"
        breadcrumb={breadcrumb}
        color="#222"
      />
     
      <section className="privacyPage">
        <div className="privacyContainer">
          <div className="privacyCard">

            <div className="privacySection">
              <h2>Information We Gather from You:</h2>

              <h3>Personal Information</h3>

              <p>
                We At <strong>property4sure.com</strong>, respect the online privacy of the visitor and recognise the need for an appropriate protection of any personal information you share with us. We do not collect any personal information from a visitor to our site unless that visitor explicitly and intentionally provides it. Under no circumstances do we collect any personal data revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership, health, or sex life. If you are simply browsing our site, we do not gather any personal information about you. <strong>property4sure.com</strong> does not disclose the personal data of the visitor for any secondary purposes.
              </p>
            </div>

            <div className="privacySection">
              <h2>Statistical Information About Your Visit</h2>

              <p>
                When you visit our site, our computers may automatically collect statistics about your visit. This information does not identify you personally, but rather about a visit to our site. We may monitor statistics such as how many people visit our site, the user’s IP address, which pages people visit, from which domains our visitors come and which browsers people use. We use these statistics about your visit for aggregation purposes only. These statistics are used to help us improve the performance of our Web site.
              </p>
            </div>

            <div className="privacySection">
              <h2>Sending Responses & Updates</h2>
              <p>
                We generally respond to any E-mail questions, requests for product or service information, and other inquiries that we receive. We may also retain this correspondence to improve our products, services, and Web site, and for other disclosed purposes. Frequently we retain contact information for communication to enable us to send individuals updates or other important information about our services and products.
              </p>
            </div>

            <div className="privacySection">
              <h2>Consent</h2>

              <p>
                By accessing or using our website, you consent to this Privacy
                Policy and agree to the collection and use of your information as
                described herein.
              </p>

              <p>
                If you do not agree with this Privacy Policy, please discontinue
                the use of our website.
              </p>
            </div>

            <div className="privacySection">
              <h2>Changes to this Privacy Policy</h2>
              <p>
                You may access a current version of the Privacy Policy from the property4sure.com website. We may update our Privacy Policy from time to time. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
              </p>
            </div>

            <div className="privacySection">
              <h2>Contact Us</h2>

              <p>
                If you have any questions, requests, or concerns regarding this
                Privacy Policy, please contact us:
              </p>

              <div className="contactBox">
                <div>
                  <strong>Phone</strong>
                  <span>+91-8178749372</span>
                </div>

                <div>
                  <strong>Email</strong>
                  <span>info@property4sure.com</span>
                </div>
              </div>
            </div>

            <div className="privacySection" id="policy">
              <h2>Privacy Policy Statement</h2>

              <p>
                Privacy Policy is a legal document that stipulates the ways a business proprietor/company/entity collects the data of the party, discloses how and why their information will be used along with who has the access to it.
              </p>

              <p>
                This Privacy Policy provides you with particulars about the ways in which the data of the Visitor is collected, stored & used by our website. You are advised to read this Privacy Policy carefully. By visiting our website, you expressly give us consent to use & disclose your personal information in accordance with this Privacy Policy. If you do not agree to the terms of the Policy, please do not use or access our website.
              </p>

              <p>
                This Privacy Statement applies to property4sure.com website (A Unit of Deswal and Sons Consultants Pvt Ltd). Please note that our site may contain links to other sites. property4sure.com is not responsible for the privacy practices, privacy statements, or content regarding these other sites.
              </p>
            </div>

            <div className="privacySection" id='disclaimer'>
              <h2>Disclaimer</h2>

              <p>
                 Property4Sure is only an intermediary offering its platform to facilitate the transactions between Seller and Customer/Buyer/User and is not and cannot be a party to or control in any manner any transactions between the Seller and the Customer/Buyer/User. Property4Sure shall neither be responsible nor liable to mediate or resolve any disputes or disagreements between the Customer/Buyer/User and the Seller and both Seller and Customer/Buyer/User shall settle all such disputes without involving Property4Sure in any manner.
              </p>
            </div>

          </div>

        </div>
      </section>
    
    </>
  )
}

export default TermsConditions
